import { Button } from '@akin-home/buttons/native';
import { StyleProp, ViewStyle } from 'react-native';
import styled from 'styled-components/native';

type Props = {
  onPress(): void;
  style?: StyleProp<ViewStyle>;
};

export function BackHeader(props: Props) {
  return (
    <Row>
      <Button
        onPress={props.onPress}
        style={props.style}
        icon="arrow-left"
        variant="text"
      >
        Back
      </Button>
    </Row>
  );
}

const Row = styled.View`
  flex-direction: row;
  width: 100%;
`;
